/**
 * Ensures the route begins with a single slash unless it's empty or a relative path.
 * Fragments (e.g., '#cookies-settings-tool') are left unchanged too.
 * Also ensures the route does not end with a slash.
 */
export default function sanitizeRoute(route: string): string {
    const normalized = route.trim();

    // Do not modify empty strings, fragments, or relative paths (e.g., './about', '../contact')
    if (
        !normalized ||
        normalized.startsWith('./') ||
        normalized.startsWith('../') ||
        normalized.startsWith('#')
    ) {
        return normalized;
    }

    // Remove trailing slash if present
    const trimmed = normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;

    // Ensure exactly one leading slash
    return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}
